import { RealTimeData } from "~types/types";

export default function isMarketOpen(
  tradingDate: string,
  realTimeData?: RealTimeData
) {
  const marketOpenDateTime = new Date(
    `${tradingDate}T${realTimeData?.sessionStart}Z`
  );
  const marketCloseDateTime = new Date(
    `${tradingDate}T${realTimeData?.sessionEnd}Z`
  );

  const now = new Date();

  return now >= marketOpenDateTime && now <= marketCloseDateTime;
}
